var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackedPeaksHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 73L180 79L360 55L540 73L720 67L900 61L900 0L720 0L540 0L360 0L180 0L0 0Z",
    fill: "#00cc8e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 109L180 127L360 91L540 115L720 115L900 109L900 59L720 65L540 71L360 53L180 77L0 71Z",
    fill: "#0ca97a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 277L180 247L360 235L540 265L720 241L900 235L900 107L720 113L540 113L360 89L180 125L0 107Z",
    fill: "#168866"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 385L180 391L360 373L540 367L720 367L900 385L900 233L720 239L540 263L360 233L180 245L0 275Z",
    fill: "#1b6e55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 433L180 427L360 427L540 403L720 403L900 433L900 383L720 365L540 365L360 371L180 389L0 383Z",
    fill: "#1b6e55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 505L180 517L360 505L540 499L720 499L900 517L900 431L720 401L540 401L360 425L180 425L0 431Z",
    fill: "#168866"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 565L180 571L360 559L540 565L720 565L900 559L900 515L720 497L540 497L360 503L180 515L0 503Z",
    fill: "#0ca97a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 601L180 601L360 601L540 601L720 601L900 601L900 557L720 563L540 563L360 557L180 569L0 563Z",
    fill: "#00cc8e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedPeaksHaikei);
export default __webpack_public_path__ + "static/media/stacked-peaks-haikei.af843a231fad40af1fe2ffe4c11ec8a9.svg";
export { ForwardRef as ReactComponent };